import React, { useRef, useState, useEffect } from 'react'
import Logo from "../Images/newlogo.svg"
import Logo2 from "../Images/zindua-app-logo.svg"
import { Link } from 'react-router-dom'
import Button from "react-bootstrap/Button";
import Form from "react-bootstrap/Form";
import Spinner from 'react-bootstrap/Spinner';
import { getAuth, signInWithEmailAndPassword } from "firebase/auth";
import { useNavigate } from 'react-router-dom';
import swal from 'sweetalert';
import { doc, getDoc, getFirestore } from "firebase/firestore";
import { app } from "../firebase";

function Login() {

  const emailRef = useRef();
  const passwordRef = useRef();
  const navigate = useNavigate();
  const auth = getAuth();

  const [signUpBtn, setSignUpbtn] = useState(true)
  const [loadingBtn, setLoadingBtn] = useState(false)

  // ====== SEO & Meta Tags ======
  useEffect(() => {
    document.title = "Zindua App | Login";

    let desc = document.querySelector("meta[name='description']");
    if (!desc) {
      desc = document.createElement("meta");
      desc.setAttribute("name", "description");
      document.head.appendChild(desc);
    }
    desc.setAttribute("content", "Login to your Zindua App account to connect with influencers and monetize your audience.");

    // Open Graph tags
    const ogTags = [
      { property: "og:title", content: "Zindua App | Login" },
      { property: "og:description", content: "Login to your Zindua App account to connect with influencers and monetize your audience." },
      { property: "og:type", content: "website" },
      { property: "og:url", content: "https://zindua.app/login" },
      { property: "og:image", content: "https://zindua.app/logo192.png" },
    ];

    ogTags.forEach(({ property, content }) => {
      let tag = document.querySelector(`meta[property='${property}']`);
      if (!tag) {
        tag = document.createElement("meta");
        tag.setAttribute("property", property);
        document.head.appendChild(tag);
      }
      tag.setAttribute("content", content);
    });

    // JSON-LD structured data
    const script = document.createElement("script");
    script.type = "application/ld+json";
    script.text = JSON.stringify({
      "@context": "https://schema.org",
      "@type": "Organization",
      name: "Zindua",
      url: "https://zindua.app",
      logo: "https://zindua.app/logo192.png",
      sameAs: [
        "https://www.instagram.com/zindua.app/",
        "https://www.linkedin.com/company/zindua-app/",
        "https://www.tiktok.com/@zindua.app"
      ],
      contactPoint: {
        "@type": "ContactPoint",
        telephone: "+254795156925",
        contactType: "customer support",
        email: "hello@zindua.app"
      }
    });
    document.head.appendChild(script);

    return () => {
      document.head.removeChild(script);
    };
  }, []);



  function LoginUser() {

    const email = emailRef.current.value;
    const password = passwordRef.current.value;

    setSignUpbtn(false);
    setLoadingBtn(true);

    signInWithEmailAndPassword(auth, email, password)
      .then(async (userCredential) => {
        const userId = userCredential.user.uid;

        const db = getFirestore(app);
        const userDoc = await getDoc(doc(db, "users", userId));

        if (userDoc.exists()) {
          const userType = userDoc.data().userType;

          if (userType === "An Influencer") {
            navigate("/dashboard");
          } else {
            navigate("/user/dashboard");
          }
        } else {
          swal("Error", "User record not found.", "error");
        }
      })
      .catch((error) => {
        setSignUpbtn(true);
        setLoadingBtn(false);
        const errormessage = error.message;
        const cleanMessage = error.message
          .replace("Firebase: Error (auth/", "")
          .replace(").", "")
          .replace(/-/g, " ")
          .toLowerCase()
          .replace(/^\w/, c => c.toUpperCase())

        swal("Sign Up error", cleanMessage, "error")
      });

  }
  return (
    <div className='authPage'>
      <div className='authLeft'>
        <div className='authLeftBg'></div>
      </div>

      <div className='authRight'>
        <div className='authRightcont'>
          <Link to="/" className='authRightLogo'>
            <img src={Logo} alt="" />
          </Link>
          {/* <h1>Login</h1> */}
          <p>Enter your email and password to login to your account</p>
          <br />

          <Form.Group className="mt-3">
            <Form.Label>Email Address</Form.Label>
            <Form.Control
              type="email"
              placeholder="email"
              ref={emailRef}
            />
          </Form.Group>

          <Form.Group className="mt-3">
            <Form.Label>Password</Form.Label>
            <Form.Control
              type="password"
              placeholder="password"
              ref={passwordRef}

            />
          </Form.Group>

          <div className='forgotCont'>
            <Form.Group className="mt-3">
              <Form.Check
                type="radio"
                id="rememberMe"
                name="rememberMe"
                label="Remember me"
              />
            </Form.Group>
            <Link to="/forgot-password">Forgot Password?</Link>
          </div>

          <div className='bottomBtnCont'>
            {signUpBtn &&
              <Button onClick={LoginUser} variant="primary" className="mt-3 btnLogin w-100" >Sign In</Button>
            }
            {loadingBtn && <Button variant="primary" disabled className='mt-3 btnLogin w-100'>
              <Spinner
                as="span"
                animation="border"
                size="sm"
                role="status"
                aria-hidden="true"
              />
              {" "}Signing In...
            </Button>
            }
            <Link to="/register">Dont Have an Account? Sign Up</Link>
          </div>




        </div>
      </div>
    </div>
  )
}

export default Login